import type { ColumnTypeFn } from "../types";

export const numberType: ColumnTypeFn = (value) => {
  if (value == null) return <span className="text-muted">-</span>;
  return <>{String(value)}</>;
};
